<template>
  <div class="flex flex-col gap-1 bg-teal-50 p-3 border border-teal-100 rounded-lg">
    <span
      v-for="item in items"
      :key="item"
      class="flex items-center gap-1 text-sm text-gray-700"
    >
      <Check class="w-5 text-teal-600" />
      <span>{{ item.label }}</span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { Check } from 'lucide-vue-next'

const props = withDefaults(
  defineProps<{
    firstLabel: string
    secondLabel: string
    thirdLabel: string
  }>(),
  {
    firstLabel: '',
    secondLabel: '',
    thirdLabel: '',
  }
)

const items = computed(() => {
  return [
    {
      label: props.firstLabel,
    },
    {
      label: props.secondLabel,
    },
    {
      label: props.thirdLabel,
    },
  ]
})
</script>

<style lang="postcss" scoped>
.giftcard-booking-icon-line {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
